import { motion } from 'framer-motion';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const galleryCategories = [
  { id: 'all', label: 'All Events' },
  { id: 'health', label: 'Health Screenings' },
  { id: 'education', label: 'Education Workshops' },
  { id: 'fashion', label: 'Fashion Shows' },
  { id: 'community', label: 'Community Outreach' },
];

const galleryImages = [
  {
    id: 1,
    category: 'community',
    title: 'Community Education Event',
    description: 'Families and community members gathering for health education and awareness',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/3124fc77bd95185372b821a3459dc36e.jpeg',
  },
  {
    id: 2,
    category: 'community',
    title: 'The Connect Gala - Where Impact Meets Style',
    description: 'Celebrating our team and community impact at our annual fundraising gala',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/1022bafea314062ab36ccc0896688ed9.jpeg',
  },
  {
    id: 3,
    category: 'education',
    title: 'One Voice, One Fight - End Stigma Panel',
    description: 'Powerful panel discussion addressing mental health stigma and community healing',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/52dd75a818c0ae044cf650c47815c87e.jpeg',
  },
  {
    id: 4,
    category: 'education',
    title: 'Wellness Education Workshop',
    description: 'Comprehensive wellness education covering heart health, mental health, diabetes, and preventive care',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/d37b3d25d5340ba8e3c8937988b89e9d.jpeg',
  },
  {
    id: 5,
    category: 'education',
    title: 'One Voice, One Fight - Team Unity',
    description: 'Team members and community advocates united in ending mental health stigma with Hope Psychiatric Consultants',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/0cec4252043eb8289712eb3c34aee1b9.jpeg',
  },
  {
    id: 6,
    category: 'community',
    title: 'Community Wellness Fair Booth',
    description: 'Team members engaging with community at wellness fair, providing health resources and wellness gift bags',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/d9a8c6877d8a74c8ace796d7039dafe6.jpeg',
  },
  {
    id: 7,
    category: 'education',
    title: 'Heart Health Education Workshop',
    description: 'Engaging heart health presentation featuring anatomical education and cardiovascular wellness teaching',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/88235457c351861f655a820ede12e562.jpeg',
  },
  {
    id: 8,
    category: 'community',
    title: 'HER Testimony - Domestic Violence Awareness',
    description: 'Empowering survivors and advocates united in raising awareness about domestic violence prevention and support',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/f055649e376af9a6b3bd6939e5479f96.jpeg',
  },
  {
    id: 21,
    category: 'community',
    title: 'HER Testimony - Strength in Unity',
    description: 'Powerful gathering of advocates and survivors standing together in solidarity against domestic violence',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/6c121ee655d20e2f455451097848dca1.jpeg',
  },
  {
    id: 22,
    category: 'community',
    title: '1 Heart Brand Ambassador',
    description: 'Showcasing the 1 Heart Health and Wellness brand identity and mission through stylish representation',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/1dc2b100a2bfcbb48008d5abe0205b00.jpeg',
  },
  {
    id: 23,
    category: 'community',
    title: '1 Heart Community Outreach',
    description: 'Team members at Jones Drugs community outreach event providing health resources and wellness information',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/a5d6947e505582b0fb036f8ee4894675.jpeg',
  },
  {
    id: 24,
    category: 'fashion',
    title: '1 Heart Fashion Show - Creative Health Education',
    description: 'Models showcasing creative fashion designs that educate about health issues, combining style with powerful health awareness messages',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/521a66533e9871f89591bb6fe601518f.jpeg',
  },
  {
    id: 9,
    category: 'health',
    title: 'Breast Cancer Screening Event',
    description: 'Free mammogram screenings for underserved communities',
    image: 'https://public.readdy.ai/ai/img_res/a28c7bd54f2f95b42dbe6b849f7a6270.jpg',
  },
  {
    id: 10,
    category: 'fashion',
    title: 'Health Through Fashion Show',
    description: 'Educating about health issues through creative fashion',
    image: 'https://readdy.ai/api/search-image?query=fashion%20show%20runway%20with%20diverse%20models%20wearing%20creative%20outfits%20representing%20health%20awareness%20themes%20with%20audience%20watching%20volunteers%20coordinating%20backstage%20colorful%20lighting%20and%20health%20education%20messages%20displayed%20on%20screens%20in%20community%20event%20venue&width=800&height=600&seq=gallery002&orientation=landscape',
  },
  {
    id: 11,
    category: 'education',
    title: 'Heart Health Workshop',
    description: 'Teaching community members about cardiovascular wellness',
    image: 'https://readdy.ai/api/search-image?query=cardiac%20nurse%20practitioner%20teaching%20heart%20health%20workshop%20to%20diverse%20community%20group%20with%20anatomical%20heart%20model%20healthy%20food%20displays%20and%20educational%20posters%20volunteers%20assisting%20attendees%20taking%20notes%20in%20bright%20community%20center%20room&width=800&height=600&seq=gallery003&orientation=landscape',
  },
  {
    id: 12,
    category: 'community',
    title: 'Community Health Fair',
    description: 'Annual wellness event serving 500+ community members',
    image: 'https://readdy.ai/api/search-image?query=large%20outdoor%20community%20health%20fair%20with%20multiple%20tents%20and%20booths%20volunteers%20in%20matching%20tshirts%20helping%20diverse%20families%20children%20playing%20health%20screening%20stations%20food%20vendors%20and%20people%20smiling%20under%20sunny%20sky%20with%20banners%20and%20balloons&width=800&height=600&seq=gallery004&orientation=landscape',
  },
  {
    id: 13,
    category: 'education',
    title: 'Diabetes Education Session',
    description: 'Dr. King teaching diabetes management and prevention',
    image: 'https://readdy.ai/api/search-image?query=african%20american%20female%20doctor%20teaching%20diabetes%20education%20class%20to%20diverse%20group%20showing%20blood%20glucose%20monitor%20and%20healthy%20meal%20planning%20charts%20volunteers%20distributing%20educational%20materials%20in%20welcoming%20community%20room%20with%20engaged%20attendees&width=800&height=600&seq=gallery005&orientation=landscape',
  },
  {
    id: 26,
    category: 'education',
    title: 'Diabetes Informational Workshop',
    description: 'Interactive diabetes education workshop providing vital health information and resources to the community',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/21920bdb12b25d4466c667f260ce01eb.jpeg',
  },
  {
    id: 14,
    category: 'health',
    title: 'Massage Therapy Wellness Day',
    description: 'Free therapeutic massage services for cancer survivors',
    image: 'https://readdy.ai/api/search-image?query=licensed%20massage%20therapist%20providing%20therapeutic%20massage%20to%20cancer%20survivor%20in%20peaceful%20wellness%20room%20with%20soft%20lighting%20aromatherapy%20candles%20and%20volunteers%20creating%20calming%20healing%20environment%20with%20comfortable%20massage%20tables%20and%20soothing%20decor&width=800&height=600&seq=gallery006&orientation=landscape',
  },
  {
    id: 15,
    category: 'community',
    title: 'Domestic Violence Support Group',
    description: 'Creating safe spaces for survivors and families',
    image: 'https://readdy.ai/api/search-image?query=diverse%20women%20sitting%20in%20supportive%20circle%20at%20domestic%20violence%20support%20group%20meeting%20with%20counselor%20facilitating%20discussion%20in%20safe%20comfortable%20room%20with%20tissues%20resources%20pamphlets%20and%20empowering%20posters%20showing%20hope%20and%20healing&width=800&height=600&seq=gallery007&orientation=landscape',
  },
  {
    id: 16,
    category: 'fashion',
    title: 'Kids Models Workshop',
    description: 'Youth empowerment through modeling and confidence building',
    image: 'https://readdy.ai/api/search-image?query=diverse%20children%20learning%20modeling%20poses%20and%20confidence%20skills%20with%20enthusiastic%20coach%20in%20bright%20studio%20mirrors%20showing%20kids%20practicing%20runway%20walks%20smiling%20volunteers%20helping%20young%20models%20with%20colorful%20outfits%20and%20positive%20affirmations%20on%20walls&width=800&height=600&seq=gallery008&orientation=landscape',
  },
  {
    id: 17,
    category: 'health',
    title: 'Mental Health Awareness Event',
    description: 'Breaking stigma and providing mental wellness resources',
    image: 'https://readdy.ai/api/search-image?query=mental%20health%20awareness%20event%20with%20diverse%20people%20participating%20in%20mindfulness%20activities%20counselors%20providing%20resources%20volunteers%20distributing%20mental%20wellness%20information%20green%20ribbons%20and%20supportive%20atmosphere%20in%20community%20center%20with%20calming%20colors&width=800&height=600&seq=gallery009&orientation=landscape',
  },
  {
    id: 27,
    category: 'education',
    title: 'Mental Health Podcast Recording',
    description: 'Recording mental health awareness podcast to reach and educate the community about mental wellness and breaking stigma',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/70dd83da10fba3320926b900e713061a.jpeg',
  },
  {
    id: 29,
    category: 'community',
    title: 'Team No Limit Ground Breakers Recognition',
    description: 'Celebrating community leadership and impact at the Team No Limit Ground Breakers awards ceremony, recognizing dedication to health and wellness advocacy',
    image: 'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/196ea8e7cd237bc627830df50de1cffd.jpeg',
  },
  {
    id: 18,
    category: 'education',
    title: 'Nutrition and Healthy Eating Workshop',
    description: 'Teaching families about heart-healthy meal preparation',
    image: 'https://readdy.ai/api/search-image?query=nutrition%20workshop%20with%20diverse%20families%20learning%20healthy%20cooking%20techniques%20fresh%20vegetables%20and%20fruits%20displayed%20volunteers%20demonstrating%20meal%20prep%20cardiac%20nurse%20teaching%20heart%20healthy%20recipes%20in%20bright%20community%20kitchen%20with%20cooking%20stations&width=800&height=600&seq=gallery010&orientation=landscape',
  },
  {
    id: 19,
    category: 'community',
    title: 'Volunteer Appreciation Day',
    description: 'Celebrating our dedicated volunteer family',
    image: 'https://readdy.ai/api/search-image?query=diverse%20group%20of%20volunteers%20celebrating%20together%20at%20appreciation%20event%20wearing%20matching%20tshirts%20holding%20certificates%20and%20awards%20smiling%20and%20hugging%20with%20decorations%20balloons%20and%20thank%20you%20banners%20in%20festive%20community%20venue&width=800&height=600&seq=gallery011&orientation=landscape',
  },
  {
    id: 20,
    category: 'health',
    title: 'Mastectomy Fitting Services',
    description: 'Providing compassionate post-surgical care and support',
    image: 'https://readdy.ai/api/search-image?query=certified%20mastectomy%20fitter%20providing%20compassionate%20fitting%20consultation%20to%20breast%20cancer%20survivor%20in%20private%20comfortable%20room%20with%20prosthetics%20displays%20supportive%20atmosphere%20and%20professional%20caring%20environment%20showing%20dignity%20and%20respect&width=800&height=600&seq=gallery012&orientation=landscape',
  },
];

export default function GalleryPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-cream">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://readdy.ai/api/search-image?query=collage%20of%20diverse%20community%20service%20activities%20volunteers%20helping%20people%20at%20health%20events%20fashion%20shows%20and%20educational%20workshops%20showing%20teamwork%20compassion%20and%20community%20impact%20with%20warm%20lighting%20and%20joyful%20expressions%20representing%20nonprofit%20organization%20mission&width=1920&height=600&seq=galleryhero001&orientation=landscape"
            alt="Community Service"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="inline-block bg-coral/90 text-white px-6 py-2 rounded-full text-sm font-semibold mb-6">
              Our Impact in Action
            </span>
            <h1 className="font-serif text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Community Gallery
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Witness the transformative power of community service through our events, programs, and the lives we've touched together
            </p>
          </motion.div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 bg-white sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {galleryCategories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  selectedCategory === category.id
                    ? 'bg-coral text-white shadow-lg'
                    : 'bg-gray-100 text-charcoal hover:bg-gray-200'
                }`}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            layout
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {filteredImages.map((item, index) => (
              <motion.div
                key={item.id}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                className="group cursor-pointer"
              >
                <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all">
                  {/* Image */}
                  <div className="relative overflow-hidden h-72">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="font-serif text-xl font-bold text-charcoal mb-2 group-hover:text-coral transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-r from-coral to-pink">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-6">
              Be Part of Our Story
            </h2>
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Join us in creating more moments of impact, healing, and community transformation
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="/get-involved"
                className="inline-block bg-white text-coral px-8 py-4 rounded-full text-base font-semibold hover:bg-cream transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                Volunteer With Us
              </a>
              <a
                href="/programs"
                className="inline-block bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-coral transition-all cursor-pointer whitespace-nowrap"
              >
                View Our Programs
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}